import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ColumnMode, DatatableComponent, SelectionType } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '@core/services/language.service';
import { ToastrService } from 'ngx-toastr';
// import { LanguageService } from '@core/services/language.service';

@Component({
  selector: 'app-z-privacy-policy',
  templateUrl: './z-privacy-policy.component.html',
  styleUrls: ['./z-privacy-policy.component.scss'],
            encapsulation: ViewEncapsulation.None
  
})
export class ZPrivacyPolicyComponent implements OnInit {
  public arrCoupons: any[] = [];
 


  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
        private language : LanguageService,
                private toastr : ToastrService
                ,public _translateService: TranslateService

  ) {} 
  public lang : any

  public currentPage = 1;  
  public itemsPerPage = 10;
  public totalItems = 0;
  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;

 
  public levels: any[] = [];
  public tempData = [];
  public currentLang : string

  @ViewChild(DatatableComponent) table: DatatableComponent;

   

  // ngOnInit(): void {
  //   this.getLevels();

  // }
  ngOnInit(): void {

                        this.currentLang = localStorage.getItem('currentLang')

    this.language.currentLang.subscribe((res: string) => {
this.lang = res; 
});

    this.apisService.privacyPolicy().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
this.getLevels();
    
  }
 


  getLevels() {
  this.apisService.privacyPolicy().subscribe({ 
      next:(response:any)=> { 
        this.arrCoupons = response.data || [] ;
        console.log('response is' , this.arrCoupons)
      }, 
      error:(err)=> { 
        console.log('error in fetching', err)
      }
    })
  }

 

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.arrCoupons = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }

   confirmDelete(id:any){ 
  this.apisService.Deletenotifications(id).subscribe({
  next: (response: any) => {
  this.toastr.success(
    this.currentLang === 'ar'
      ? 'تم الحذف بنجاح'
      : 'Deleted successfully'
  );

  this.getLevels();
},

error: (error: any) => {
  console.error(error);

  this.toastr.error(
    this.currentLang === 'ar'
      ? 'حدث خطأ ما'
      : 'Something went wrong'
  );
}

  }
)}


formatContent(content: string): string {
  if (!content) return '';

  return content
    .replace(/---/g, '<hr>')
    .replace(/\n\n/g, '<br><br>')
    .replace(/\n/g, '<br>');
}


enableEdit(item: any) {
  item.isEditing = true;

  item._backup = {
    title_ar: item.title_ar,
    title_en: item.title_en,
    content_ar: item.content_ar,
    content_en: item.content_en
  };
}
cancelEdit(item: any) {
  item.isEditing = false;

  item.title_ar = item._backup.title_ar;
  item.title_en = item._backup.title_en;
  item.content_ar = item._backup.content_ar;
  item.content_en = item._backup.content_en;
}
submitEdit(item: any) {
  const payload = {
    title_ar: item.title_ar,
    title_en: item.title_en,
    content_ar: item.content_ar,
    content_en: item.content_en
  };

  this.apisService.editPrivacyPolicy(item.id, payload).subscribe({
    next: () => {
      this.toastr.success(
        this.currentLang === 'ar'
          ? 'تم التعديل بنجاح'
          : 'Updated successfully'
      );
      item.isEditing = false;
    },
    error: () => {
      this.toastr.error(
        this.currentLang === 'ar'
          ? 'حدث خطأ أثناء التعديل'
          : 'Error updating'
      );
    }
  });
}

    
}
